import React, { useEffect, useState } from 'react';
import { reverseGeocode } from '../../utils/geocode';

// Renders a service-location address. Uses the stored `fallback` (booking.location)
// if present; otherwise reverse-geocodes the pin (for older bookings saved before
// addresses were captured).
const AddressText = ({ lat, lng, fallback, className = '', testId }) => {
  const [addr, setAddr] = useState(fallback || '');

  useEffect(() => {
    let active = true;
    if (fallback && fallback.trim()) { setAddr(fallback); return; }
    if (lat != null && lng != null) {
      reverseGeocode(lat, lng).then((a) => { if (active && a) setAddr(a); });
    }
    return () => { active = false; };
  }, [fallback, lat, lng]);

  if (!addr) return null;

  return (
    <span className={className} data-testid={testId}>{addr}</span>
  );
};

export default AddressText;
